import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { forwardRef } from 'react';
import { useTestIdAttribute, } from '../../../hooks/useTestIdAttribute';
import { Hint } from '../../Hint/Hint';
import { Text } from '../../Text/Text';
import { Box } from '../../layout/Box';
import { FlexContainer } from '../../layout/FlexContainer';
import { useIsErrorTestAttribute } from '../useIsErrorTestAttribute';
export const RadioGroup = forwardRef(({ children, error, testId, ...rest }, ref) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const errorTestIdAttribute = useTestIdAttribute(`${testId}-error`);
    const isErrorTestAttribute = useIsErrorTestAttribute(!!error);
    return (_jsxs(FlexContainer, { direction: 'column', gap: true, children: [_jsx(RadixRadioGroup.Root, { ref: ref, ...rest, ...testIdAttribute, ...isErrorTestAttribute, children: children }), error && (_jsx(Box, { width: 'fit-content', children: _jsx(Hint, { variant: 'danger', ...errorTestIdAttribute, children: _jsx(Text, { variant: 'b2', children: error }) }) }))] }));
});
